import React from 'react';
import { Tabs } from 'antd';
import RecipeVariantsPanel from './RecipeVariantsPanel';
import RecipeBomPanel from './RecipeBomPanel';
import RecordOrderPanel from './RecordOrderPanel';
import GeneralInstructionsPanel from '@/components/GeneralInstructionsPanel';

// Shared by EditRecipeModal (existing recipe) and the post-create step on
// RecipeMetaData (brand-new recipe) — same panels either way.
// hideAddVariant: passed straight through to RecipeVariantsPanel — see its own comment.
//
// RV11 added "Process flow": until then a record could not state what waits for what, so
// `ORDER_NOT_STATED` had a finding in the readiness rail and nowhere for the author to go
// and fix it. This is that somewhere — and it is the destination `readinessModel`'s
// RECORD_FINDINGS table names for both order findings.
// showVariants (2026-10-12): an MBMR is opened without its Variants tab — the record has one fixed
// output and the tab only ever said so; the MFR screen still shows it.
// Each tab scrolls inside its own area (2026-10-12) — long content never stretches the dialog.
const PANE = { maxHeight: 'min(560px, 58vh)', overflowY: 'auto', overflowX: 'hidden', paddingRight: 4 };
// 2026-10-21 (owner) · the MBMR's general instructions are back (optional): shown on the tablet merged
// with each process's own instruction before its first step. Not on an MFR's content record (hideAddVariant).
export default function RecipeBomVariantsTabs({ recipeId, hideAddVariant, showVariants = true, showInstructions = false, readOnly = false, onInstructionsChange, batchSize, batchUom, massUom }) {
  return (
    <Tabs
      size="small"
      defaultActiveKey={showVariants ? 'variants' : 'bom'}
      items={[
        showVariants ? { key: 'variants', label: 'Variants', children: <RecipeVariantsPanel recipeId={recipeId} hideAddVariant={hideAddVariant} /> } : null,
        { key: 'bom', label: 'BOM', children: <div style={PANE}><RecipeBomPanel recipeId={recipeId} batchSize={batchSize} batchUom={batchUom} massUom={massUom} /></div> },
        { key: 'order', label: 'Process flow', children: <div style={PANE}><RecordOrderPanel recipeId={recipeId} /></div> },
        showInstructions ? {
          key: 'instructions',
          label: 'General instructions',
          children: <GeneralInstructionsPanel recipeId={recipeId} readOnly={readOnly} onStateChange={onInstructionsChange} />,
        } : null,
      ].filter(Boolean)}
    />
  );
}
